<template>
    <b-form @submit.stop.prevent="saveClicked">
        <b-card class="card-custom">
            <template v-slot:header>
                <h4 class="card-title">Настройки аккаунта</h4>
                <div class="card-toolbar">
                    <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                              @click="loadSettings"
                    >
                        <i class="fa fa-sync"/>
                    </b-button>
                    <b-button type="submit" variant="success">Сохранить</b-button>
                </div>
            </template>
            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
            <b-form-group id="input-group-curpassword" label-cols="4" label-cols-lg="3"
                          label="Текущий пароль" label-for="input-curpassword">
                <b-form-input id="input-oldcur" v-model="curPassword" type="password" maxlength="100"
                              ref="inputCurPassword"/>
            </b-form-group>
            <b-form-group label-cols="4" label-cols-lg="3">
                <h6 class="mt-2 mb-0">Привязка к IP-адресу (подсети)</h6>
            </b-form-group>
            <b-form-group id="input-group-ipbind" label-cols="4" label-cols-lg="3"
                          label="Привязка включена" label-for="check-ipbind">
                <b-form-checkbox switch size="lg" id="check-ipbind" class="mt-2"
                                 v-model="ipBind"/>
            </b-form-group>
            <b-form-group id="input-group-ipaddress" label-cols="4" label-cols-lg="3"
                          ref="inputIpAddress"
                          label="IP адрес (подсеть)" label-for="input-ipaddress"
            >
                <b-form-input id="input-ipaddress" v-model="ipAddresses"/>
                <div class="mt-1 text-muted">
                    Ваш IP адрес: <a href="#" @click.prevent="putCurrentIpAddress">{{currentIpAddress}}</a>
                </div>
                <div class="mt-1 text-muted">Несколько IP-адресов можно разделить точкой с запятой</div>
            </b-form-group>
        </b-card>
    </b-form>
</template>

<script>
    import axios from "axios";

    export default {
        name: "AccountSettings",
        data() {
            return {
                userData: this.$store.getters.getUserData,

                err: false,
                errText: "",
                errVariant: "danger",

                loadProcessing: false,

                curPassword: "",
                ipBind: false,
                ipAddresses: "",
                currentIpAddress: ""

            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.inputCurPassword.$el.focus()
            })
            this.loadSettings()
            this.loadCurrentIpAddress()
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            loadCurrentIpAddress() {
                axios.get("/ws/ws.svc/GetUserRemoteHost",
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (typeof resp.data.success === "undefined" || typeof resp.data.response === "undefined"
                            || typeof resp.data.data === "undefined") {

                        } else {
                            if (resp.data.success) {
                                this.currentIpAddress = resp.data.data, toString()
                            } else {

                            }
                        }
                    })
            },
            loadSettings() {
                axios.post("/ws/ws.svc/GetUserIPBindingSettings", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (typeof resp.data.success === "undefined" || typeof resp.data.response === "undefined"
                            || typeof resp.data.IPBind === "undefined") {
                            this.errTextShow("Неверный формат ответа.")
                        } else {
                            if (resp.data.success) {
                                this.ipAddresses = resp.data.response.toString()
                                this.ipBind = resp.data.IPBind
                            } else {
                                this.errTextShow(resp.data.result.toString(), "danger", true)
                            }
                        }
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            putCurrentIpAddress() {
                if (this.currentIpAddress !== "") {
                    this.ipAddresses = this.currentIpAddress
                    this.ipBind = true
                    this.$refs.inputIpAddress.$el.children[1].firstChild.focus()
                }
            },
            saveClicked() {
                this.errTextHide()

                if (this.curPassword.trim().length === 0) {
                    this.errTextShow("Введите текущий пароль.", "info")
                    this.$refs.inputCurPassword.$el.focus()
                    return
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/ChangeUserIPBinding", {
                        'Session_UID': this.userData.Session_UID,
                        'CurrentPassword': this.curPassword,
                        'IPBind': (this.ipBind ? 1 : 0),
                        'IPAddresses': this.ipAddresses
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (typeof resp.data.success === "undefined" || typeof resp.data.response === "undefined") {
                            this.errTextShow("Неверный формат ответа.")
                        } else {
                            if (resp.data.success) {
                                this.errTextShow("Данные успешно изменены!", "info")
                            } else {
                                this.errTextShow(resp.data.response.toString())
                            }
                        }

                        this.loadProcessing--
                        this.curPassword = ""
                        this.$refs.inputCurPassword.$el.focus()
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при обработке данных (" + err.message + ")")
                        this.loadProcessing--
                        this.curPassword = ""
                        this.$refs.inputCurPassword.$el.focus()
                    })
            }
        },
        watch: {
            operationProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>

</style>